import { render, staticRenderFns } from "./AdminProductTypeList.vue?vue&type=template&id=3987c226"
import script from "./AdminProductTypeList.vue?vue&type=script&lang=js"
export * from "./AdminProductTypeList.vue?vue&type=script&lang=js"
import style0 from "./AdminProductTypeList.vue?vue&type=style&index=0&id=3987c226&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports